<template>
  <div class="entry-loader">
    <div class="entry-loader__top">
        <div class="entry-loader__top__loader">
          <div class="entry-loader__top__text">
            Loading...
          </div>
      </div>
    </div>
     <div class="entry-loader__bottom">
      <div class="entry-loader__bottom__content">
        {{copy}}
      </div>
    </div>
  </div>
</template>

<script>
import { CONTENT_ENTRY_FORM_LOADER_COPY } from '../../design-tokens/build/dictionary';

export default {
  name: 'entry-loader',
  data() {
    return {
      copy: CONTENT_ENTRY_FORM_LOADER_COPY
    };
  }
};
</script>

<style lang="scss">
.entry-loader {
  height: $size-height-entry-loader-large;
  font-size: $size-text-entry-loader-large;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  @include global-media('small') {
    height: $size-height-entry-loader-small;
  font-size: $size-text-entry-loader-small;
  }
  &__top {
    flex: 1 1 auto;
    position: relative;
    margin-bottom: $size-margin-entry-loader-top-large;
    @include global-media('small') {
      margin-bottom: $size-margin-entry-loader-top-small;
    }

    &__loader {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: flex-end;
    }
    &__text {

    }
  }
  &__bottom {
    flex: 1 1 auto;
    &__text {

    }
  }
}
</style>
